import React from "react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

import { useGetLocationData, useSetLocationData } from "~/hooks/locationData";

import PaginationBtns from "./PaginationBtns";

import s from "./Pagination.less";

interface IPagination {
  showPadding?: boolean;
  showRight?: boolean;
  showRightAll?: boolean;
  showPagination?: boolean;
  showline?: boolean;
  modal?: boolean;
  total: number;
  isElements?: boolean;
}

const Pagination: React.FC<IPagination> = ({
  children,
  total,
  showPadding = false,
  modal = false,
  showPagination = false,
  showRight = false,
  showRightAll = false,
  showline = false,
  isElements = false,
}) => {
  const { t } = useTranslation();
  const setData = useSetLocationData();
  const { count, countModal } = useGetLocationData();

  const setCount10 = () => {
    setData(
      modal ? "countModal" : "count",
      25,
      modal ? "pageModal" : "page",
      0
    );
  };
  const setCount25 = () => {
    setData(
      modal ? "countModal" : "count",
      50,
      modal ? "pageModal" : "page",
      0
    );
  };
  const setCount50 = () => {
    setData(
      modal ? "countModal" : "count",
      100,
      modal ? "pageModal" : "page",
      0
    );
  };

  return (
    <div className={s.root}>
      {!showPagination && (
        <div
          className={clsx(s.show, {
            [s.showPadding]: showPadding,
            [s.showRight]: showRight,
            [s.showRightAll]: showRightAll,
          })}
        >
          <span>{t("ui.show_by")}</span>
          <div className={s.check}>
            <div className={s.b_checkbox1}>
              <div
                onClick={setCount10}
                className={clsx({
                  [s.btn]: true,
                  [s.active]: modal
                    ? Number(countModal) === 25
                    : Number(count) === 25,
                })}
              >
                25
              </div>
            </div>
            <div className={s.b_checkbox1}>
              <div
                onClick={setCount25}
                className={clsx({
                  [s.btn]: true,
                  [s.active]: modal
                    ? Number(countModal) === 50
                    : Number(count) === 50,
                })}
              >
                50
              </div>
            </div>
            <div className={s.b_checkbox1}>
              <div
                onClick={setCount50}
                className={clsx({
                  [s.btn]: true,
                  [s.active]: modal
                    ? Number(countModal) === 100
                    : Number(count) === 100,
                })}
              >
                100
              </div>
            </div>
          </div>
        </div>
      )}

      {children}

      <div className={s.wrap}>
        <div className={s.pagination}>
          <PaginationBtns modal={modal} total={total} />
        </div>
        <div
          className={clsx(s.lines, {
            [s.lines_padding]: showline,
          })}
        >
          <br />
          {isElements
            ? t("ui.number_of_elements")
            : t("ui.number_of_lines")}{" "}
          <strong>{total}</strong>
        </div>
      </div>
    </div>
  );
};
export default Pagination;
